// extracted by mini-css-extract-plugin
export default {"btn":"ExportButton_btn__nzEHm","text":"ExportButton_text__gIldS"};